import { Component, OnInit } from '@angular/core';
import {User} from '../../../../generated/graphql';
import {Store} from '@ngrx/store';
import {GlobalService} from '../../../shared/services/global.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ProxyService} from '../../../shared/services/proxy.service';
import {TranslateService} from '@ngx-translate/core';
import {CustomPermissionsService} from '../../../shared/services/custom-permissions.service';
import {BaseComponent} from '../../../shared/base/base.component';
import {AppState} from '../../../store/app.reducer';
import {SetToolbarButtons} from '../../../fixed-toolbar/fixed-toolbar.action';
import {UserFetch} from '../store/users.actions';

@Component({
    selector: 'app-user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent extends BaseComponent implements OnInit {

    private editId = null;
    public loadedUser: User;

    constructor(
        protected store: Store<AppState>,
        protected gs: GlobalService,
        protected route: ActivatedRoute,
        protected proxyService: ProxyService,
        private translate: TranslateService,
        private ps: CustomPermissionsService
    ) {
        super(store, gs);
    }

    ngOnInit(): void {
        this.subs.sink = this.route.params.subscribe((params: Params) => {
            this.editId = +params.id;
            this.fetchUser(this.editId);

            this.buttons = [];

            this.subs.sink = this.ps.getNgxPermissions$().subscribe(() => {
                this.ps.hasPermission('createUsers').then((permission) => {
                    this.buttons = [...this.buttons];
                    if (permission) {
                        this.buttons.push(
                            {
                                id: 'createUserButton',
                                name: 'users.create',
                                action: 'onCreateUser',
                                class: 'p-button-primary',
                                icon: 'pi pi-plus',
                                disabled: false,
                            }
                        );
                    }
                    this.store.dispatch(new SetToolbarButtons(this.buttons));
                });
            });
        });
    }

    fetchUser(userId: number) {
        this.subs.sink = this.store.select('users').subscribe(state => {
            this.loadedUser = state.loadedUser;
        });
        this.store.dispatch(new UserFetch({userId}));
    }
}
